export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.27-1334.03",
  commitId: "2eb2966be60326f4102450c4f28896d1fe3d2961",
  commitTime: "2026-05-27T13:34:03.000Z",
});
